import { render } from "./invitationDetail.vue?vue&type=template&id=70b68ccf&scoped=true"
import script from "./invitationDetail.vue?vue&type=script&lang=js"
export * from "./invitationDetail.vue?vue&type=script&lang=js"

import "./invitationDetail.vue?vue&type=style&index=0&id=70b68ccf&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b68ccf"]])

export default __exports__